<template>
  <div class="pc_sticky_btns">
    <!-- <div class="sticky_btn">
      <button class="btn btn_photo_reserve" @click="translate" data-to="contact">
        <p class="reserve_text">ただいま<span class="clinic_state">{{ isOpen ? '診療中' : '休診中' }}</span><br><span class="reserve_emphasis">お問い合わせはこちら</span></p>
        <img class="photo" src="/assets/img/common/img_doctor.png">
      </button>
    </div> -->
    <div class="sticky_btn"><button class="btn btn_circle btn_arrow_u icon-" @click="translate" data-to="HOME"></button></div>
    <!-- <div class="sticky_btn" :class="{'negative': isNegative}">
      <a :href="hp" target="_blank" rel="noreferrer"><img src="/assets/img/common/icon_official.svg" alt="">OFFICIAL</a>
    </div> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PcStickyBtns',
  props: {
    msg: String,
    isNegative: Boolean
  },
  data () {
    return {
      hp: siteData.info.hp
    }
  },
  computed: {
    ...mapState([
      'siteData',
      'isOpen'
    ])
  },
  methods: {
    ...mapActions([
      'smoothScroll'
    ]),
    translate (e) {
      const gotoName = e.currentTarget.attributes['data-to'].value
      const scrollPos = document.querySelector(`.panel[data-tab="${gotoName}"]`).offsetTop
      this.smoothScroll({
        duration: 100,
        scrollPos: scrollPos
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
